<div bsModal #loginSettingsModal="bs-modal" class="eup-modal modal fade" [config]="{backdrop: 'static', keyboard: false}">
    <div class="modal-dialog modal-lg">
        <div class="modal-content">
            <div class="modal-header">
                <h3 class="modal-title">
                    <button logClick *ngIf="!mustChangePassword" id="btn-hide-settings" type="button" class="close close-sign" (click)="hide()" [disabled]="isSubmitting" [ngClass]="{'disabled' : isSubmitting}">
                        <svg class="svg-backButton32 svg-backButton32-dims"></svg>
                    </button>
                    <div *ngIf="isExternalProvider; else loginTemplate">
                        {{ 'Settings.ResetPassword' | translate }}
                    </div>
                    <ng-template #loginTemplate>
                        {{ 'Settings.Login' | translate }}
                    </ng-template>
                </h3>
            </div>
            <div class="modal-body" *ngIf="!isExternalProvider">
                <form [formGroup]="settingsForm" class="form-horizontal settings-modal" novalidate (keyup.enter)="submitSettings(settingsForm.value)" onsubmit="return false;">
                    <div class="form-group eup-textbox">
                        <label class="col-sm-4 control-label">{{'Settings.Email' | translate }}</label>
                        <div class="col-sm-8">
                            <p class="form-control-static">{{loginEmail}}</p>
                        </div>
                    </div>

                    <div class="form-group eup-textbox" [ngClass]="{ 'has-error' : !validationState.settingsPassword.valid && submitAttempted }">
                        <label for="settingsPassword" class="col-sm-4 control-label">{{'Settings.Current_Password' | translate }}</label>
                        <div class="col-sm-8">
                            <tlk-text-input formControlName="settingsPassword" type="password" [name]="settingsPassword" [id]="'settingsPassword'" #settingsPassword>
                                <div tlk-error *ngIf="validationState.settingsPassword.errors.required">{{'Settings.Password_Error' | translate }}</div>
                                <div tlk-error *ngIf="validationState.settingsPassword.errors.badCredentials">{{'Settings.Bad_Credentials' | translate }}</div>
                            </tlk-text-input>
                        </div>
                    </div>

                    <div class="form-group eup-textbox" [ngClass]="{ 'has-error' : !validationState.settingsNewPassword.valid && submitAttempted }">
                        <label for="settingsNewPassword" class="col-sm-4 control-label">{{'Settings.New_Password' | translate }}</label>
                        <div class="col-sm-8">
                            <tlk-text-input formControlName="settingsNewPassword" [name]="settingsNewPassword" [id]="'settingsNewPassword'" #settingsNewPassword [type]="password">   
                                <div tlk-error *ngIf="validationState.settingsNewPassword.errors.required">{{'Settings.New_Password_Error' | translate }}</div>
                                <div tlk-error *ngIf="validationState.settingsNewPassword.errors.password">
                                    {{'Settings.Password_Policy_Error' | translate }}
                                    <a href="javascript:void(0);" id="password-policy-link-on-error" (click)="onPasswordPolicyClick()">{{'Settings.Password_Policy' | translate }}</a>
                                </div>
                            </tlk-text-input>
                        </div>
                    </div>

                    <div class="form-group eup-textbox" [ngClass]="{ 'has-error' : !validationState.settingsConfirmPassword.valid && submitAttempted }">
                        <label for="settingsConfirmPassword" class="col-sm-4 control-label">{{'Settings.Confirm_New_Password' | translate }}</label>
                        <div class="col-sm-8">
                            <tlk-text-input formControlName="settingsConfirmPassword" type="password" [name]="settingsConfirmPassword" [id]="'settingsConfirmPassword'" #settingsConfirmPassword>
                                <div tlk-error *ngIf="validationState.settingsConfirmPassword.errors.required">{{'Settings.New_Password_Confirm_Error' | translate }}</div>
                                <div tlk-error *ngIf="validationState.settingsConfirmPassword.errors.equivalent">{{'Settings.Password_Mismatch' | translate }}</div>
                            </tlk-text-input>
                        </div>
                    </div>

                    <div class="form-group eup-textbox" [ngClass]="{ 'has-error' : !validationState.settingsSecurityQuestion.valid && submitAttempted }">
                        <label for="settingsSecurityQuestion" class="col-sm-4 control-label">{{'Settings.Security_Question' | translate }}</label>
                        <div class="col-sm-8 control-label">
                            <select logClick [objectType]="BiObjectType.Combobox" formControlName="settingsSecurityQuestion" class="form-control" name="settingsSecurityQuestion" id="settingsSecurityQuestion">
                                <option *ngFor="let question of securityQuestionList" [ngValue]="question">{{'Settings.' + question | translate }}</option>
                            </select>
                            <span *ngIf="validationState.settingsSecurityQuestion.errors.required"
                                  class="col-sm-12 help-block">{{'Settings.Security_Question_Error' | translate }}</span>
                        </div>
                    </div>
                    
                    <div class="form-group eup-textbox" [ngClass]="{ 'has-error' : !validationState.settingsSecurityAnswer.valid && submitAttempted }">
                        <label for="settingsSecurityAnswer" class="col-sm-4 control-label">{{'Settings.Security_Answer' | translate }}</label>
                        <div class="col-sm-8">
                            <tlk-text-input formControlName="settingsSecurityAnswer" type="text" [name]="settingsSecurityAnswer" [id]="'settingsSecurityAnswer'" #settingsSecurityAnswer [required]="true">
                                <div tlk-error *ngIf="validationState.settingsSecurityAnswer.errors.required">{{'Settings.Security_Answer_Error' | translate }}</div>
                            </tlk-text-input>
                        </div>
                    </div>

                    <div class="form-group">
                        <div class="col-sm-2 text-left">
                            <a href="javascript:void(0);" id="password-policy-link" (click)="onPasswordPolicyClick()">{{'PasswordPolicy.Password_Policy_Link' | translate }}</a>
                        </div>
                        <div class="col-sm-offset-4 col-sm-3 text-right">
                            <a logClick *ngIf="!mustChangePassword" id="btn-cancel" class="cancel" (click)="hide()" [ngClass]="{'disabled' : isSubmitting || mustChangePassword}">{{'Settings.Cancel' | translate }}</a>
                        </div>
                        <div class="col-sm-3">
                            <button id="btn-submit"
                                logClick
                                type="button"
                                class="btn btn-primary btn-lg btn-block"
                                (click)="submitSettings(settingsForm.value)"
                                [disabled]="isSubmitting">{{'Settings.Submit' | translate }}
                            </button>
                        </div>
                    </div>
                </form>
            </div>
            <div class="modal-body" *ngIf="isExternalProvider">
                <form [formGroup]="settingsForm" class="form-horizontal" novalidate (keyup.enter)="submitSettings(settingsForm.value)" onsubmit="return false;">
                    <div class="reset-password">
                        <label class="control-label">{{'Settings.Email' | translate }}:</label>
                        <span class="email"><p class="">{{loginEmail}}</p></span>
                    </div>

                    <div class="reset-password-button">
                        <button id="reset-btn-submit"
                            logClick
                            type="button"
                            class="reset-password-button btn btn-primary btn-lg btn-block"
                            
                            (click)="resetPassword()"
                            [disabled]="isSubmitting">{{'Settings.ResetPassword' | translate }}
                        </button>
                    </div>
                </form>
            </div>
        </div>
    </div>
</div>

<confirm-reset-password-popup [isSubmitting]="isSubmitting" (resetPasswordEvent)="resetPassword()" [show]="showConfirmModal" class="from-doctor"/>